import { User } from 'interfaces/user'
import moment from 'moment'
import {
  Card,
  Col,
  Button,
  InputGroup,
  FormControl,
  Dropdown,
  DropdownButton,
  Form,
  Modal,
} from 'react-bootstrap'
import React, { useState, useEffect } from 'react'
import TextInformationLine from '../text-information-line'
import { LINQ_EMAIL_DOMAIN } from 'constants/empty'
import useUpdateUser from 'hooks/use-update-user-new'
import toast from 'react-hot-toast'
import { Organization } from 'interfaces/organization'
import { useHistory } from 'react-router'
import { useQueryClient } from 'react-query'
import useMutationAdminDeleteUser from 'hooks/use-mutation-admin-delete-user'
import useDeletePhoneNumber from 'hooks/use-delete-worknumber'
import { usersQueryKeys } from 'utils/query-keys'

const UserProfileNew = ({
  user,
  setShowPushTokensModal,
  primaryOrg,
}: {
  user: User
  setShowPushTokensModal: React.Dispatch<React.SetStateAction<boolean>>
  primaryOrg: Organization
}) => {
  const [copiedField, setCopiedField] = useState<string | null>(null)
  // const [maxPages, setMaxPages] = useState('')
  // const [slackId, setSlackId] = useState<string>()
  // const updateUser = useUpdateUser(user?.uuid)
  // const updateUserMetaData = useUpdateUserMetaData(user?.uuid, user?.id)

  // useEffect(() => {
  //   setMaxPages(user?.max_pages?.toString() || '')
  // }, [user?.max_pages])

  // useEffect(() => {
  //   if (user?.internal_slack_id) {
  //     setSlackId(user.internal_slack_id)
  //   }
  // }, [user])

  // Check if user has active organization subscription
  // const subscriptionStatus =
  //   primaryOrg?.organization_subscription?.subscription_status
  // const hasActiveOrgSubscription =
  //   subscriptionStatus === OrganizationSubscriptionStatus.Active ||
  //   subscriptionStatus === OrganizationSubscriptionStatus.Trialing

  // const handleUpdateUserToInternalAdmin = ({
  //   updatedField,
  // }: {
  //   updatedField: boolean
  // }) => {
  //   if (updatedField) {
  //     if (
  //       window.confirm(
  //         `Are you sure you want to make ${user.name} as LINQ INTERNAL ADMIN?`
  //       )
  //     ) {
  //       updateUser.mutate(
  //         { linq_internal_admin: updatedField },
  //         {
  //           onSuccess: () => {
  //             toast('Update user to Linq internal admin', { icon: `👍` })
  //           },
  //         }
  //       )
  //     }
  //   } else {
  //     updateUser.mutate(
  //       { linq_internal_admin: updatedField },
  //       {
  //         onSuccess: () => {
  //           toast('Remove user from Linq internal admin', { icon: `👍` })
  //         },
  //       }
  //     )
  //   }
  // }

  // const handleUpdateUserToHaveUnlimitedPage = ({
  //   updatedField,
  // }: {
  //   updatedField: boolean
  // }) => {
  //   updateUser.mutate({ can_have_unlimited_pages: updatedField })
  // }

  // const handleUpdateNumberOfAllowedPages = (e: React.FormEvent) => {
  //   e.preventDefault()
  //   if (maxPages) {
  //     updateUserMetaData.mutate(
  //       {
  //         max_pages_override: parseInt(maxPages),
  //       },
  //       {
  //         onSuccess: () => {
  //           toast(`Successfully updated user's max pages`, { icon: `👍` })
  //         },
  //       }
  //     )
  //   }
  // }

  // const handleUpdateSlackId = (e: React.FormEvent) => {
  //   e.preventDefault()
  //   if (slackId) {
  //     updateUser.mutate(
  //       {
  //         internal_slack_id: slackId,
  //       },
  //       {
  //         onSuccess: () => {
  //           toast(`Successfully updated Slack ID! 🎉`, { icon: `🎈` })
  //         },
  //       }
  //     )
  //   }
  // }

  const handleCopy = (text: string, field: string) => {
    navigator.clipboard.writeText(text)
    setCopiedField(field)
    setTimeout(() => setCopiedField(null), 2000)
  }

  const CopyableField = ({ text, field }: { text: string; field: string }) => (
    <div
      onClick={() => handleCopy(text, field)}
      className="text-break"
      style={{ cursor: 'pointer', display: 'inline-block' }}
      title={copiedField === field ? 'Copied!' : 'Click to copy'}
    >
      {text}{' '}
      <ion-icon
        name={copiedField === field ? 'checkmark-outline' : 'copy-outline'}
        style={{
          color: copiedField === field ? '#28a745' : '#10B981',
          fontSize: '16px',
        }}
      />
    </div>
  )

  const [showEditModal, setShowEditModal] = useState(false)
  const [editForm, setEditForm] = useState({
    name: user?.name || '',
    email: user?.email || '',
    phone_number: user?.phone_number || '',
  })

  const updateUser = useUpdateUser(user?.uuid)
  const queryClient = useQueryClient()
  const history = useHistory()

  const handleEdit = () => {
    setEditForm({
      name: user?.name || '',
      email: user?.email || '',
      phone_number: user?.phone_number || '',
    })
    setShowEditModal(true)
  }

  const handleCancel = () => {
    setShowEditModal(false)
    setEditForm({
      name: user?.name || '',
      email: user?.email || '',
      phone_number: user?.phone_number || '',
    })
  }

  const validateEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  }

  const handleSave = () => {
    // Validate email if it's provided
    if (editForm.email && !validateEmail(editForm.email)) {
      toast.error('Please enter a valid email address')
      return
    }

    updateUser.mutate(editForm, {
      onSuccess: () => {
        toast.success('User updated successfully!')
        setShowEditModal(false)
        // Force additional query invalidations to ensure UI updates
        queryClient.invalidateQueries(usersQueryKeys.detail(user?.uuid))
        queryClient.invalidateQueries(['users'])
        queryClient.invalidateQueries(['admin/api/v1/users/search'])
      },
    })
  }

  const handleFormChange = (field: string, value: string) => {
    setEditForm((prev) => ({
      ...prev,
      [field]: value,
    }))
  }

  // Delete User mutation
  const deleteUserMutation = useMutationAdminDeleteUser({
    onSuccess: () => {
      toast(`User successfully deleted!`, { icon: `🗑` })
      history.replace('/users')
      queryClient.invalidateQueries(`admin/api/v1/users/search`)
    },
  })
  const handleDeleteUserClicked = () => {
    if (
      window.confirm(
        'Are you sure you want to delete this user? This cannot be undone. Make sure that you have consent from the owner of this account to delete it.'
      ) === true
    ) {
      if (
        window.confirm(
          'Ok. If you are really really sure, please just confirm once more before we delete the user forever...'
        )
      ) {
        deleteUserMutation.mutate(user?.uuid)
      }
    }
  }
  const handlePhoneNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target
    // Remove non-digit characters but allow common phone formatting characters
    const cleanedValue = value.replace(/[^\d\s()-]/g, '')

    handleFormChange('phone_number', cleanedValue)
  }

  return (
    <Col md="12">
      <Card className="mt-4">
        <Card.Header className="d-flex justify-content-between align-items-center">
          <h4>Profile</h4>
          <div className="d-flex align-items-center gap-2">
            {!showEditModal && (
              <Dropdown className="user-actions-dropdown">
                <Dropdown.Toggle
                  variant="link"
                  className="p-1 text-success text-decoration-none d-flex align-items-center fw-medium shadow-none"
                  id="user-actions-dropdown"
                  style={{ border: 'none' }}
                  bsPrefix="btn"
                >
                  Actions
                  <ion-icon
                    name="chevron-down-outline"
                    className="ms-2"
                    style={{ fontSize: '14px' }}
                  />
                </Dropdown.Toggle>

                <Dropdown.Menu className="bg-dark border-success border-2 rounded">
                  <Dropdown.Item
                    className="text-white px-3 py-2"
                    onClick={handleEdit}
                  >
                    Edit
                  </Dropdown.Item>
                  <Dropdown.Item
                    className="text-danger px-3 py-2"
                    onClick={handleDeleteUserClicked}
                  >
                    Delete
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            )}
          </div>
        </Card.Header>
        <Card.Body>
          {/* User ID */}
          <div className="mb-3">
            <div className="fw-bold mb-1">User ID</div>
            <div>
              {user?.id ? (
                <CopyableField text={user.id.toString()} field="userId" />
              ) : (
                'N/A'
              )}
            </div>
          </div>

          {/* Created on */}
          <div className="mb-3">
            <div className="fw-bold mb-1">Created on</div>
            <div>{moment(user?.created_at).format('MMMM DD, YYYY h:mm A')}</div>
          </div>

          {/* Email */}
          <div className="mb-3">
            <div className="fw-bold mb-1">Email</div>
            <div>
              {user?.email ? (
                <CopyableField text={user.email} field="email" />
              ) : (
                'N/A'
              )}
            </div>
          </div>

          {/* Name */}
          <div className="mb-3">
            <div className="fw-bold mb-1">Name</div>
            <div className="text-break">{user?.name || 'N/A'}</div>
          </div>

          {/* Phone Number */}
          <div className="mb-3">
            <div className="fw-bold mb-1">Phone Number</div>
            <div>
              {user?.phone_number ? (
                <CopyableField text={user.phone_number} field="phoneNumber" />
              ) : (
                'N/A'
              )}
            </div>
          </div>
        </Card.Body>
      </Card>

      {showEditModal && (
        <Modal
          show={showEditModal}
          onHide={handleCancel}
          centered
          dialogClassName="custom-edit-user-modal"
          style={{ borderRadius: '15px' }}
        >
          <Modal.Header className="bg-dark text-white border-0 d-flex justify-content-between align-items-center">
            <Modal.Title className="fs-4">Edit User</Modal.Title>
            <ion-icon
              name="close-outline"
              style={{
                fontSize: '24px',
                cursor: 'pointer',
                color: 'white',
              }}
              onClick={handleCancel}
            />
          </Modal.Header>
          <Modal.Body className="bg-dark px-4 py-4">
            <Form>
              <Form.Group className="mb-4">
                <Form.Label className="text-white fw-normal mb-2">
                  Name
                </Form.Label>
                <Form.Control
                  type="text"
                  value={editForm.name}
                  onChange={(e) => handleFormChange('name', e.target.value)}
                  className="py-3 px-3 bg-dark"
                  style={{
                    color: 'white',
                    fontSize: '1rem',
                    borderRadius: '10px',
                    border: '1px solid #D1D4E3',
                  }}
                />
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label className="text-white fw-normal mb-2">
                  Email
                </Form.Label>
                <Form.Control
                  type="email"
                  value={editForm.email}
                  onChange={(e) => handleFormChange('email', e.target.value)}
                  className="py-3 px-3 bg-dark"
                  style={{
                    color: 'white',
                    fontSize: '1rem',
                    borderRadius: '10px',
                    border: '1px solid #D1D4E3',
                  }}
                />
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label className="text-white fw-normal mb-2">
                  Account Phone Number
                </Form.Label>
                <Form.Control
                  type="tel"
                  value={editForm.phone_number}
                  onChange={handlePhoneNumberChange}
                  className="py-3 px-3 bg-dark"
                  style={{
                    color: 'white',
                    fontSize: '1rem',
                    borderRadius: '10px',
                    border: '1px solid #D1D4E3',
                  }}
                  placeholder="(123) 456-7890"
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer className="bg-dark border-0 px-4 py-4">
            <Button
              variant="outline-primary"
              onClick={handleCancel}
              className="px-4 py-2 me-3"
              style={{
                borderColor: '#4da6ff',
                color: '#4da6ff',
                backgroundColor: 'transparent',
                borderRadius: '10px',
              }}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={handleSave}
              disabled={updateUser.isLoading}
              className="px-4 py-2"
              style={{
                backgroundColor: '#4da6ff',
                borderColor: '#4da6ff',
                borderRadius: '10px',
              }}
            >
              {updateUser.isLoading ? 'Saving...' : 'Save'}
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </Col>
  )
}

export default UserProfileNew
